import { StaffLayout } from "@/components/layouts/staff-layout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardDescription, CardHeader, CardTitle, } from "@/components/ui/card"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useForm, usePage } from "@inertiajs/react"
import { FormEvent } from "react"
import { t } from "@/lib/i18n"
function errorMessage(value: string | string[] | undefined): string | null {
    if (!value)
        return null
    return Array.isArray(value) ? value[0] : value
}
type OrganizationOption = { value: string; label: string }

export default function StaffLocationsNew() {
    // Which billing account this restaurant is filed under. Absent on a first
    // restaurant, where there is no choice to make and the group is created
    // alongside it -- so the field renders only when the operator owns more
    // than one and the answer is genuinely theirs.
    const { organizations = [], organizationId } = usePage<{
        organizations?: OrganizationOption[]
        organizationId?: string | null
    }>().props
    const { data, setData, post, errors, processing } = useForm({
        name: "",
        organization_id: organizationId ?? organizations[0]?.value ?? "",
    })
    const baseError = errorMessage((errors as Record<string, string | string[] | undefined>).base)
    const handleSubmit = (e: FormEvent) => {
        e.preventDefault()
        post("/locations")
    }
    return (<StaffLayout>
      <div className="mx-auto w-full max-w-xl px-4">
        <Card data-testid="new-location-card">
          <CardHeader>
            <CardTitle>{t("ui.react.pages.staff.locations.new.new_location")}</CardTitle>
            <CardDescription>{t("ui.react.pages.staff.locations.new.create_location_team_can")}</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-6">
              {baseError && (<p className="rounded-md border border-destructive/20 bg-destructive/5 p-3 text-sm text-destructive">
                  {baseError}
                </p>)}
              <div className="space-y-2">
                <Label htmlFor="name">{t("ui.react.pages.staff.locations.new.name_restaurant")}</Label>
                <Input id="name" placeholder={t("ui.react.pages.staff.locations.new.location_center")} value={data.name} onChange={(e) => setData("name", e.target.value)} required/>
                {errors.name && (<p className="text-sm font-medium text-destructive">{errors.name}</p>)}
              </div>
              {organizations.length > 1 && (<div className="space-y-2">
                <Label htmlFor="organization_id">{t("ui.react.pages.staff.locations.new.organization")}</Label>
                <Select value={data.organization_id} onValueChange={(value) => setData("organization_id", value)}>
                  <SelectTrigger id="organization_id" className="w-full" data-testid="location-organization">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {organizations.map((option) => (<SelectItem key={option.value} value={option.value} data-testid={`location-organization-option-${option.value}`}>
                        {option.label}
                      </SelectItem>))}
                  </SelectContent>
                </Select>
                <p className="text-xs text-muted-foreground">{t("ui.react.pages.staff.locations.new.organization_hint")}</p>
              </div>)}
              <Button type="submit" disabled={processing} data-testid="create-location-button">{t("ui.react.pages.staff.locations.new.create_location")}</Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </StaffLayout>)
}
